import { useEffect, useContext } from "react";
import { GlobalContext } from "../../hooks/globalContext";
import Session from 'supertokens-web-js/recipe/session';
import apiCall from "../../utility/api";

interface SchemaCondtion {
  roleSchema: string;
  permissionSchema: string;
  role: string;
  creationTime: string;
  impact: string;
  benifit: string
  createdBy: string;
}

type dataProps = {
  formDataRole: any;
  formDataAdmin: any;
  saveRoleDetails?: any;
  setSaveRoleDetails?: any;
  setFormDataRole?: any;
  setFormDataAdmin?: any;
  data: any;
  func: any;
  searchVal: any
  pageNo: any
  setTotalPages: any
  setTotalRecords: any
  isFilter?: any
  dropDownValue1?: any
  setIsFilter?: any
  dropDownValue2?: any
  rowID?: any
  setRowID?: any
  handleEditData?: any
  setIsToast?: any
  isRefresh?: any
  setIsRefresh?: any
  setRefreshToast?: any
  setExportDetails?: any
  setDeleteDisabled?: any
  deleteRole?: any
  isDeleteRole?: any
  setIsDeleteRole?: any
  setIsDeleteRoleToast?: any
  isDeleteRoleToast?: any
  createNewRole?: any
  setNewRole?: any
  setEditRoleDetail?: any
  editRoleDetail?: any
  setHandlePermission?: any
  handlePermission?: any
  filterArray?: any
  setUserRoles?: any
  roleUsers?: any
  getUsersThatHaveRole?: any
  setExportBtnClicked?: any
  exportBtnClicked?: any
  tenant?: any
  setIsRoleExist?: any;
  setLoading?: any;
  setUserRoleArray?: any;
  setSpinnerLoad?: any
};

export const Admin_func = (props: dataProps) => {

  const contextValue: any = useContext(GlobalContext);
  const delRoleList = contextValue.selectedRowIdInTable;
  const rolesObject = { roles: delRoleList };
  console.log("this is the del-List", delRoleList)
  const role: any = props.formDataRole?.roleName;
  const roleSchema = JSON.stringify(props.formDataRole);
  const permissionSchema = JSON.stringify(props.formDataAdmin);
  const permissionsObject: any = (props.formDataAdmin)
  console.log("object array test", permissionsObject)
  const permissionsArray: any = [];


  Object.keys(permissionsObject).forEach(key => {
    if (typeof permissionsObject[key] === 'object' && permissionsObject[key] !== null) {
      Object.keys(permissionsObject[key]).forEach(innerKey => {
        permissionsArray.push(permissionsObject[key][innerKey]);
        console.log("final permission", permissionsArray)
      });
    } else {
      permissionsArray.push(permissionsObject[key]);
      console.log("final else permission",)

    }
  });

  const addSchema = async () => {
    console.log("User session details:", contextValue.userSessionDetails);

    let whereCondition: SchemaCondtion = {
      roleSchema: roleSchema,
      permissionSchema: permissionSchema,
      role: role,
      creationTime: Math.floor(Date.now() / 1000).toString(),
      benifit: props.formDataRole?.benefit,
      impact: props.formDataRole?.impact,
      createdBy: contextValue.userSessionDetails.userName
    }

    try {
      let data = await apiCall('/administration/addPermission', whereCondition)
      console.log("apiData=", data);
      return data && data.status === "success";
    } catch (error) {
      console.error("An unexpected error occurred:", error);
    }
  };

  const addRole = async () => {
    try {
      // Check if the role already exists
      const data = await apiCall('/administration/checkRole', { "role": role });

      if (data?.exists == true) {
        await props.setIsRoleExist(true);  // Update state for role existence
        return false;  // Early return if role exists
      } else {
        console.log('New Role!');
      }

      // Proceed to add the role to the system
      const accessToken = await Session.getAccessToken();
      const response = await apiCall('/administration/createRole', {
        "role": role,
        "permissions": permissionsArray
      }, "POST")
      if (response && response.status === "success") {
        const createRoleResp = await addSchema();
        if (createRoleResp) {
          props.setNewRole(true);
          getPermissionList(null);
          getPermissionListCnt(null);
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } catch (error) {
      console.error("An unexpected error occurred:", error);
      return false;
    }
  };


  const updateRoleDetails = async () => {

    console.log("calling update function=======>", props.formDataRole?.role)
    const role = props.formDataRole?.roleName ?? null;
    const last = Math.floor(Date.now() / 1000);
    const createdBy = contextValue.userSessionDetails.userName;
    const permissionSchema = JSON.stringify(props.formDataAdmin) ?? null;
    let dataToSend = {
      role: role,
      last: last,
      createdBy: createdBy,
      permissionSchema: permissionSchema,
      permissionsObject: permissionsObject,
      handlePermission: props.handlePermission
    }
    try {
      let data = await apiCall('/administration/upadatePermission', dataToSend)
      if (data.status == "success") {
        console.log("Updating permissions for the selected role", data)
      }
      return data;
    } catch (error) {
      console.error("An unexpected error occurred:", error);
    }

  };

  const deleteRole = async () => {
    // Disable the delete button while the operation is in progress
    props.setDeleteDisabled(true);
    console.log("CALLING DELETE-ROLE");

    try {
      const accessToken = await Session.getAccessToken();
      const response = await apiCall('/administration/deleteRoles',
        { roles: delRoleList },
        "POST"
      );

      if (response && response.status === 'success') {
        await getPermissionList(null, 50, parseInt(props.pageNo));

        // Hide the delete toast message after 2 second
        setTimeout(() => {
          props.setIsDeleteRole(false);
          props.setIsDeleteRoleToast(false);
        }, 2000);
      } else {
        console.error('Failed to delete role');
        // Optionally, you can set a failure toast or message here
      }
    } catch (error) {
      console.log("API ERROR delete role", error);
    }
  };


  const getPermissionList = async (whereCondition: any, limit: Number | null = null, offset: Number | null = null) => {
    try {
      //need to ask let after comparision
      let data = await apiCall('/administration/getPermission', { ...whereCondition, limit, offset })

      if (data.status === 'success') {
        props.func(data);
        props.setLoading(true);
      }
      console.log("apiData=", data);
    } catch (error) {
      console.error("getPermissionList error=", error);
      props.func([]);
    }
  };

  const getPermissionListCnt = async (whereCondition: any) => {
    try {
      let { data, status } = await apiCall('/administration/getPermissionCnt', whereCondition)
      console.log('respdata: ', data)
      if (status === 'success' && data.totalRecords > 0) {
        props?.setTotalRecords(data.totalRecords);
        props?.setTotalPages(data.totalPages);
      }
    } catch (error) {
      console.log("getPermissionListsCnt error=", error);
    }
  };

  const getExportData = async (condition: object) => {
    try {
      const { status, data } = await apiCall(`/administration/getPermission`, condition);

      if (status === 'success') {
        props.setExportDetails && props.setExportDetails(data);
      }
    } catch (error) {
      console.log("getExportData error=", error);
    }
    props.setExportBtnClicked(false);
  }

  const getRoleDetails = async () => {
    const roleId = props.rowID;
  if (!roleId) return;

  const dataToSend = { roleId };
    console.log(roleId, "this is row id")
    try {
      const { data, status } = await apiCall('/administration/roleDetails', dataToSend)
      console.log("data length ", data.length)
      if (status === "success" && data.length > 0) {
        console.log('data[0]?.permissionSchema ' + data[0]?.permissionSchema)
        console.log("calling user that has role");
        await getUsersThatHaveRole(roleId);
      if (data[0]?.roleSchema) {props.handleEditData(data[0]?.roleSchema); props.setSpinnerLoad(false)}
      if (data[0]?.permissionSchema) props.setHandlePermission(data[0]?.permissionSchema);
      }
    } catch (error) {
      console.log("getRoleDetails error =", error);
      props.handleEditData([]);
      props.setHandlePermission([])
    }

  }
  const getEmailsQuery = async (userIds: String[]) => {
    try {
      const data = await apiCall('/administration/getEmail', { userIds });
      if (data) {
        props?.setUserRoles(data) //need to show only unique emails
      }
    } catch (error) {
      console.error("getEmailsQuery error=", error);
      props.func([]);
    }
  }

  const getUsersThatHaveRole = async (role: String) => {
    if (!role) return;
  
    try {
      const { data } = await apiCall(`/administration/getUsersThatHaveRole/${role}`, { role });
      if (data) {
        await getEmailsQuery(data);
      }
    } catch (error) {
      console.error('getUsersThatHaveRole Error:', error.message);
    }
  };

  useEffect(() => {
    if (props.searchVal?.length > 0 && props.searchVal !== '') {
      getPermissionList({ search: props.searchVal, type: 'search' }, 50, parseInt(props?.pageNo));
      getPermissionListCnt({ search: props.searchVal, type: 'search' });
    }
    else if (props.isFilter === true) {
      getPermissionList({ filter: props.filterArray, type: 'filter' }, 50, parseInt(props.pageNo));
      getPermissionListCnt({ filter: props.filterArray, type: 'filter' });

    } else {
      getPermissionList(null, 50, parseInt(props.pageNo));
      getPermissionListCnt(null);
    }
    if (props.isDeleteRole) {
      deleteRole();
      props.setDeleteDisabled(true);
      setTimeout(() => {
        console.log("second attempt");
        props.setIsDeleteRoleToast(true);
      }, 2000);
      // setTimeout(() => {
      //   props.setIsDeleteRole(false);
      //   props.setIsDeleteRoleToast(false);
      // }, 1000);
      getPermissionList(null, 50, parseInt(props.pageNo));
    }
    else if (props.editRoleDetail == true) {
      console.log("calling the upadte function")
      updateRoleDetails();
      console.log()
      // getEmailsQuery()
      props?.setFormDataRole({});
      props?.setFormDataAdmin({});
      // props.setRowID({})
      props.setRowID(null)
      setTimeout(() => {
        props.setEditRoleDetail(false)
      }, 5000);
    }
    //getPermissionList(null,10,parseInt(props.pageNo));
  }, [ props.searchVal, props.isDeleteRole, props.pageNo, props.isFilter, props.editRoleDetail, props.setRowID, props.filterArray]);

  useEffect(() => {
    if (props.saveRoleDetails === true) {
      addRole().then((roleCreated) => {
        if (roleCreated) {
          props.setIsToast(true);
          return true

        } else {
          throw new Error('Failed to create role');
        }
      }).then(() => {
        // getPermissionList(null);
        // getPermissionListCnt(null);
        // Call other necessary functions after successful role creation and schema addition
      }).catch((error) => {
        console.error('An unexpected error occurred:', error);
      }).finally(() => {
        props.setSaveRoleDetails(false);
        props.setFormDataRole({});
        props.setFormDataAdmin({});
        props.setIsToast(true);
      });
    }
    if (props.rowID) {
      getRoleDetails();
      // getUsersThatHaveRole(props.rowID);
    }
  }, [props.rowID, props.saveRoleDetails]);

  //separeate useeffect to avoid loading 
	useEffect(()=>{
		if (props.exportBtnClicked) {
      getExportData({ function: 'export', tenant: props.tenant });
		}
		if (props.isRefresh) {
			getPermissionList(null, 50, parseInt(props.pageNo));
			getPermissionListCnt(null);
		}
	},[props.exportBtnClicked,props.isRefresh])

  return <></>;
};